module.exports = __webpack_public_path__ + "static/img/24_sister.1ac208fa.jpg";